<nz-empty
  nzNotFoundImage="./assets/images/not-found.png"
  [nzNotFoundContent]="contentTpl"
  [nzNotFoundFooter]="footerTpl"
>
  <ng-template #contentTpl>
    <span>
      {{ title }}
    </span>
  </ng-template>
  <ng-template #footerTpl>
    <button nz-button nzType="primary" (click)="onClick()">{{ buttonText }}</button>
  </ng-template>
</nz-empty>